export default __webpack_public_path__ + "static/media/Copy.9396fefb.svg";